export const catalog_matrix = [
  {form_key:'fiscal_regime_id', catalog_key:'business_fiscal_regimes'},
  {form_key:'business_status_id', catalog_key:'business_statuses'},
]